import { Directive } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Observable, debounceTime, of } from 'rxjs';
import { AdminService } from '../services/admin.service';

@Directive({
  selector: '[appUserIDValidator]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: UserIDValidatorDirective, multi: true }]
})
export class UserIDValidatorDirective implements AsyncValidator {

  constructor(private adminService:AdminService) { }
  validate(control: AbstractControl): Promise<{ [key: string]: any } | null> | Observable<{ [key: string]: any } | null> {

    if(control?.value && control.value != '')

    return new Promise((resolve,reject)=>{
      setTimeout(() =>{
      this.adminService.validateUserID(control.value).pipe(debounceTime(10)).subscribe(
          (res:any) => {
                if (res.body == null) {
                  resolve(null);
                }
                else {
                  resolve({ userIDExists: true });
                }
              }
        )},100);
    })
    return of(null);
  }

}

